<template>
  <div class="notification">
    <div class="count">
      {{ notification.count }}
    </div>
    <a
      class="message-row body-color"
      :class="{ unread: notification.unread }"
      @click.prevent="notificationClicked(notification)"
    >
      <!-- <avatar :user="{ id: 0, avatar_url: notification.data.avatar_url }" /> -->

      <div class="message">
        <div v-if="message.header">
          <b>{{ message.header }}</b>
        </div>
        {{ message.snippet }} [{{ message.status }}]
        <div class="timestamp">
          {{ dateFromNow(message.timestamp) }}
        </div>
      </div>
    </a>
    <a
      href="#"
      class="close"
      @click.prevent="deleteNotification"
    >
      &times;
    </a>
  </div>
</template>

<script>
// import Avatar from '@/components/Avatar.vue';

export default {
  components: {
    // Avatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    message() {
      return this.notification.last_message.notification;
    },
  },
  methods: {
    async notificationClicked(notification) {
      if (notification.status !== 'read') {
        await this.api({
          url: 'notifications/threads/',
          method: 'DELETE', // 'PUT'
          json: {
            thread: notification.thread,
            // status: 'read',
          },
        });
      }
      if (this.message.link) {
        this.$router.push(this.message.link);
      }
    },
    async deleteNotification() {
      const response = await this.api({
        url: 'notifications/threads/',
        method: 'DELETE',
        json: {
          thread: this.notification.thread,
        },
      });
      if (response.ok) {
        this.$emit('deleted');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  a {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: auto 1fr;
    padding: 0.5rem;
    background-color: #fff;
    transition: background-color 0.2s ease-in-out;
    font-size: .8rem;

    &:focus,
    &:hover {
      background-color: var(--gray-lightest);
    }
  }

  .unread {
    border-right: 5px solid var(--red);
  }

  .timestamp {
    font-size: 80%;
    color: var(--gray-dark);
  }
  .notification {
    display: flex;
    flex-direction: row;
  }
  .body-color {
    flex: 1 1 auto;
  }
  .close {
    flex: 0 0 auto;
  }
  .message-row {
    display: flex;
  }
  .message {
    flex: 1 1 auto;
  }
  .count {
    flex: 0 0 auto;
    font-weight: thin;
    opacity: 0.7;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
</style>
